.HeadlineButton {
    &:global(.MuiButton-root) {
        font-weight: 500;
        padding: 1rem 2rem;
        font-size: 1.125rem;
        line-height: 1.75rem;
    }
}
